// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutPaymentDetailsStyles } from "@rpsc/Overrides/Widgets/OnePageCheckout/OnePageCheckoutPaymentDetails";
import { constants } from "@rpsc/XDL/constants";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

onePageCheckoutPaymentDetailsStyles.paymentDetailsHeadingText = {
    variant: "h3",
    css: css`
        margin: 0;
    `,
};

onePageCheckoutPaymentDetailsStyles.form = {
    css: css`
        width: 100%;
    `,
};

onePageCheckoutPaymentDetailsStyles.fieldset = {
    css: css`
        margin: 0;
        padding: 0;
        border: 0;
        width: 100%;
    `,
};

onePageCheckoutPaymentDetailsStyles.poNumberGridItem = {
    width: [12, 12, 12, 12, 6],
    css: css`
        &&& {
            max-width: 454px;
            ${xScreen("lte", "md")} {
                max-width: 100%;
            }
        }
        display: flex;
        flex-direction: column;
        gap: 24px;
    `,
};

onePageCheckoutPaymentDetailsStyles.containerGrid = {
    gap: 22,
    offsetCss: css`
        justify-content: space-between;
        ${xScreen("lte", "md")} {
            &&&& {
                flex-direction: column;
            }
        }
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentItem = {
    width: [12, 12, 12, 12, 6],
    css: css`
        &&& {
            max-width: 454px;
            ${xScreen("lte", "md")} {
                max-width: 100%;
            }
        }
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

onePageCheckoutPaymentDetailsStyles.creditCardTitle = {
    variant: "h6",
    forwardAs: "p",
    transform: "capitalize",
    css: css`
        margin-bottom: 12px;
    `,
};
onePageCheckoutPaymentDetailsStyles.creditCardDetailsGridItem = {
    width: 12,
    css: css`
        &&&& {
            flex-direction: column;
        }
    `,
};

onePageCheckoutPaymentDetailsStyles.divider = {
    css: css`
        margin: 6px 0 16px 0;
        border-top: 1px solid ${color("common.border")};
        width: 100%;
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentProfileBillingAddress = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-top: 16px;
            padding-top: 16px;
            border-top: 1px solid ${color("common.border")};
            width: 100%;
        `,
    },
    label: {
        variant: "h6",
        forwardAs: "p",
        css: css`
            margin: 0;
        `,
    },
};

onePageCheckoutPaymentDetailsStyles.eCheckDetailsGridItem =
    onePageCheckoutPaymentDetailsStyles.adyenDropInGridItem =
    onePageCheckoutPaymentDetailsStyles.paymentMethodGridItem =
    onePageCheckoutPaymentDetailsStyles.paymentProfileMethodDetailsGridItem =
        {
            width: 12,
        };

onePageCheckoutPaymentDetailsStyles.paymentMethodDetailsGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-top: 8px;
        }
    `,
};

onePageCheckoutPaymentDetailsStyles.creditCardAddress = {
    container: {
        gap: 12,
    },
    heading: {
        variant: "h6",
        forwardAs: "p",
        css: css`
            margin-bottom: 0;
            border-top: 1px solid ${color("common.border")};
            padding-top: 16px;
            width: 100%;
        `,
    },
};

onePageCheckoutPaymentDetailsStyles.paymentProfileEditCardLink = {
    mergeCss: true,
    css: css`
        white-space: nowrap;
        align-items: flex-start;
        margin: 5px 0 25px 10px;
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentProfileExpiredErrorWrapper = {
    css: css`
        display: flex;
        align-items: center;
        width: 100%;
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentMethodAndPONumberContainer = {
    gap: 10,
};
